import React from 'react';
import Modal, { ComponentModalProps } from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import CaseForwarder from './CaseForwarder';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props extends ComponentModalProps {
	caseId: string;
	onSuccess?: () => void;
}

const CaseForwarderModal: React.FC<Props> = ({
	opened,
	onClose,
	caseId,
	onSuccess,
}) => {
	const { isCase } = useTreatmentContext();
	const { t } = useTranslation();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
			<Modal.Header title={t('base.shared.caseTransfer')} />
			<Modal.Content>
				<CaseForwarder
					isToggled
					caseId={caseId}
					onClose={onClose}
					onSuccess={onSuccess}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default CaseForwarderModal;
